import { motion } from "framer-motion";
import { CHAPTERS } from "@/lib/siteData";

const Reveal = ({ children, delay = 0 }) => (
  <motion.div
    initial={{ opacity: 0, y: 40 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.7, delay, ease: [0.16, 1, 0.3, 1] }}
  >
    {children}
  </motion.div>
);

export default function About() {
  return (
    <section id="about" className="relative bg-ink/70 py-24 md:py-36 overflow-hidden" data-testid="about-section">
      <div className="absolute inset-0 z-0">
        <img
          src="https://static.prod-images.emergentagent.com/jobs/88f3cf28-08a6-4c4d-a110-4a623efba473/images/b953844547a92d9f30b7cb4b7b85998d44d13eb40107fb7504c3ae229c2bb001.jpeg"
          alt=""
          className="w-full h-full object-cover opacity-15"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-ink via-ink/90 to-ink/70" />
      </div>
      <div className="relative z-10 mx-auto max-w-[1400px] px-5 md:px-10">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-start">
          <div className="lg:col-span-5 lg:sticky lg:top-28">
            <Reveal>
              <span className="font-mono text-xs uppercase tracking-[0.3em] text-brass">
                / The Manifesto
              </span>
              <h2 className="mt-6 font-display uppercase leading-[0.9] tracking-tighter text-5xl md:text-6xl">
                Built on <br />
                <span className="text-oxblood">Trust</span>, not <br />
                turnover.
              </h2>
              <p className="mt-8 font-serif italic text-xl md:text-2xl text-bone/70 leading-snug">
                "No matter if you're Wyatt Earp or a novice, the folks at N.P.
                Guns will treat you like family."
              </p>
              <p className="mt-4 font-mono text-xs uppercase tracking-[0.2em] text-bone/40">
                — Verified Yelp Review
              </p>
            </Reveal>
          </div>

          <div className="lg:col-span-7 flex flex-col">
            {CHAPTERS.map((c, i) => (
              <Reveal key={c.no} delay={i * 0.08}>
                <div className="grid grid-cols-[auto_1fr] gap-6 md:gap-10 border-t border-steel py-10 group">
                  <span className="font-display text-4xl md:text-6xl text-steel group-hover:text-brass transition-colors duration-300">
                    {c.no}
                  </span>
                  <div>
                    <h3 className="font-display uppercase text-2xl md:text-3xl tracking-tight text-bone">
                      {c.title}
                    </h3>
                    <p className="mt-3 font-body text-base md:text-lg text-bone/65 leading-relaxed max-w-xl">
                      {c.body}
                    </p>
                  </div>
                </div>
              </Reveal>
            ))}
            <Reveal delay={0.1}>
              <div className="border-t border-b border-steel py-10 grid grid-cols-3 gap-4">
                {[
                  ["35+", "Years Serving"],
                  ["4.4★", "Yelp Rating"],
                  ["Class 3", "FFL Dealer"],
                ].map(([n, l]) => (
                  <div key={l}>
                    <div className="font-display text-3xl md:text-5xl text-brass leading-none">{n}</div>
                    <div className="mt-2 font-mono text-[10px] md:text-xs uppercase tracking-[0.15em] text-bone/50">
                      {l}
                    </div>
                  </div>
                ))}
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
